export const environment = {
  // apiBaseUrl: 'http://tctapi.xenovex.com',
  apiBaseUrl: 'http://devtctapi.xenovex.com',
  tokenEndPoint: '/api/token',
  production: true,
  environment: 'PROD',
  showEnvironment: false,
  year: 1970,
};